import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { AuditLogReplacement, AuditLogReplacementType } from '../AuditLogReplacement.js';
import { File } from './File.js';
import { Resolution } from './Resolution.js';
export class Image extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.resolutions = [];
    }
    getDiffValue() {
        var _a;
        return AuditLogReplacement.create({
            id: this.getPathForSize(undefined, undefined),
            value: (_a = this.source.name) !== null && _a !== void 0 ? _a : undefined,
            type: AuditLogReplacementType.Image,
        });
    }
    getPublicPath() {
        if (this.resolutions.length > 0) {
            return this.resolutions[0].file.getPublicPath();
        }
        return this.source.getPublicPath();
    }
    getPathForSize(width, height) {
        if (this.resolutions.length == 0) {
            return this.getPublicPath();
        }
        const resolution = this.getResolutionForSize(width, height);
        return resolution.file.getPublicPath();
    }
    getResolutionForSize(width, height) {
        var _a;
        let bestResolution;
        const ratio = (_a = ((typeof window !== 'undefined') ? (window.devicePixelRatio ? window.devicePixelRatio : 1) : 1)) !== null && _a !== void 0 ? _a : 1;
        if (ratio >= 2 && width) {
            width = ratio * width;
        }
        if (ratio >= 2 && height) {
            height = ratio * height;
        }
        // Search resolution bigger than width x height, but smaller than any other resolution that is bigger
        for (const resolution of this.resolutions) {
            if ((bestResolution === undefined || ((!width || resolution.width <= bestResolution.width) && (!height || resolution.height <= bestResolution.height)))
                && (!width || resolution.width >= width)
                && (!height || resolution.height >= height)) {
                bestResolution = resolution;
            }
        }
        if (bestResolution) {
            return bestResolution;
        }
        // Get biggest resolution possible of we don't find anything bigger
        for (const resolution of this.resolutions) {
            if (bestResolution === undefined || (resolution.width >= bestResolution.width && resolution.height >= bestResolution.height)) {
                bestResolution = resolution;
            }
        }
        if (bestResolution) {
            return bestResolution;
        }
        throw new Error('No resolution found. Please first check if the image has resolutions');
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Image.prototype, "id", void 0);
__decorate([
    field({ decoder: File })
], Image.prototype, "source", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Resolution) })
], Image.prototype, "resolutions", void 0);
//# sourceMappingURL=Image.js.map